export type DeadlineSettings = {
  personal: {
    b: {
      month: number;
      day: number;
    };
    be: {
      month: number;
      day: number;
    };
  };
  business: {
    accountOffsetMonths: number;
    auditOffsetMonths: number;
    taxOffsetMonths: number;
    annualReturnOffsetYears: number;
  };
};

const DEFAULT_SETTINGS: DeadlineSettings = {
  personal: {
    b: { month: 7, day: 15 },
    be: { month: 4, day: 15 },
  },
  business: {
    accountOffsetMonths: 6,
    auditOffsetMonths: 7,
    taxOffsetMonths: 8,
    annualReturnOffsetYears: 1,
  },
};

const STORAGE_KEY = 'calendarDeadlineSettings';

export const getDeadlineSettings = (): DeadlineSettings => {
  if (typeof window === 'undefined') {
    return DEFAULT_SETTINGS;
  }
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (!stored) {
    return DEFAULT_SETTINGS;
  }
  try {
    const parsed = JSON.parse(stored) as Partial<DeadlineSettings>;
    return {
      personal: {
        b: parsed.personal?.b ?? DEFAULT_SETTINGS.personal.b,
        be: parsed.personal?.be ?? DEFAULT_SETTINGS.personal.be,
      },
      business: {
        accountOffsetMonths: parsed.business?.accountOffsetMonths ?? DEFAULT_SETTINGS.business.accountOffsetMonths,
        auditOffsetMonths: parsed.business?.auditOffsetMonths ?? DEFAULT_SETTINGS.business.auditOffsetMonths,
        taxOffsetMonths: parsed.business?.taxOffsetMonths ?? DEFAULT_SETTINGS.business.taxOffsetMonths,
        annualReturnOffsetYears: parsed.business?.annualReturnOffsetYears ?? DEFAULT_SETTINGS.business.annualReturnOffsetYears,
      },
    };
  } catch {
    return DEFAULT_SETTINGS;
  }
};

export const saveDeadlineSettings = (settings: DeadlineSettings) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
};

export const DEFAULT_DEADLINE_SETTINGS = DEFAULT_SETTINGS;
